export default __webpack_public_path__ + "static/media/volume.724156fa.svg";